import { Attr, BelongsTo, HasMany, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type InsightsEntity from "./InsightsEntity";
import type InsightsQualitativeTopic from "./InsightsQualitativeTopic";
import type User from "./User";

type InsightRatingType = "sentiment" | "exclusion" | "mention" | "topics";
type InsightReportType = "qualitative" | "insights_plus";

@Model()
class InsightsRating extends ApplicationRecord {
  static jsonapiType = "insights_ratings";

  @Attr() excluded: boolean;

  @Attr() influence: number;

  @BelongsTo() insightsEntity: InsightsEntity;

  @Attr() insightsEntityId: number;

  @Attr() insightsQueryId: number;

  @BelongsTo() insightsTopic: InsightsQualitativeTopic;

  @Attr() insightsTopicId: number;

  @Attr() keywordCount: number;

  @Attr() mentionId: number;

  @Attr() mentionKey: string;

  @Attr() mentionPublishedAt: string;

  @Attr() mentionType: string;

  @Attr() needsReview: boolean;

  @Attr() notes: string;

  @Attr() organisationId: number;

  @Attr() parentId: number;

  @Attr() qualitativeKeyMessageIds: number[];

  @Attr() rateableId: number;

  @Attr() rateableType: string;

  @Attr() ratingType: InsightRatingType;

  @Attr() reportType: InsightReportType;

  @Attr() reviewedAt: string;

  @Attr() sentiment: number;

  @Attr() subTopic: string;

  @Attr() topic: string;

  @HasMany() topicRatings: InsightsRating[];

  @BelongsTo() user: User;

  @Attr() userId: number;
}

export default InsightsRating;
